import React from "react";

const DownArrowIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2752_5176)">
            <path
                d="M12.4208 6.4425L8.98431 9.8775L5.54784 6.4425L4.49219 7.5L8.98431 12L13.4764 7.5L12.4208 6.4425Z"
                fill="currentColor"
            />
        </g>

        <defs>
            <clipPath id="clip0_2752_5176">
                <rect width="17.9685" height="18" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);

export default DownArrowIcon;
